import { useState } from 'react';

import { integerToCurrency } from 'helpers';
import { ReturnRequestDetails, ReturnRequestStatus } from 'types';

import { ReturnRequestModal } from '../return-request-modal';
import { StatusBadge } from '../status-badge';

interface ReturnItemProps {
  returnRequest: ReturnRequestDetails;
}

export function ReturnItem({ returnRequest }: ReturnItemProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    consignmentCode,
    createdDate,
    protocol,
    status,
    value: { value: returnValue },
    isAvailableToRefund,
  } = returnRequest;

  return (
    <div className="flex w-full flex-col gap-4 lg:w-72">
      <div className="flex items-center gap-2">
        <p className="text-lg font-bold text-neutral-500">{protocol}</p>
        <div className="h-px flex-grow bg-neutral-300" />
        <StatusBadge
          status={status}
          isAvailableToRefund={isAvailableToRefund}
        />
      </div>

      <div className="flex flex-col gap-1 text-neutral-700">
        <p className="text-sm font-bold">Remessa</p>
        <p className="text-sm">{consignmentCode}</p>
      </div>

      <div className="flex flex-col gap-1 text-neutral-700">
        <p className="text-sm font-bold">Criação</p>
        <p className="text-sm">
          {new Date(createdDate).toLocaleDateString('pt-BR')}
        </p>
      </div>

      <div className="flex flex-col gap-1 text-neutral-700">
        <p className="text-sm font-bold">Valor da devolução</p>
        <p className="text-sm">{integerToCurrency(returnValue)}</p>
      </div>

      {status === ReturnRequestStatus.Open && (
        <>
          <button
            disabled={!isAvailableToRefund}
            onClick={() => setIsModalOpen(true)}
            className="flex w-full items-center justify-center rounded-lg
              bg-primary-300 px-4 py-2 disabled:opacity-60 sm:max-w-72"
          >
            <p className="text-sm text-neutral-100">
              {isAvailableToRefund
                ? 'Realizar devolução'
                : 'Aguarde loja concluir devolução'}
            </p>
          </button>

          {isModalOpen && isAvailableToRefund && (
            <ReturnRequestModal
              protocol={protocol}
              value={returnValue}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </>
      )}
    </div>
  );
}
